import Vue from 'vue';
import Vuex from 'vuex';
import loadImages from '@/helpers/loadImages';
import { getData, sendForm } from '@/helpers/sendForm';
import { pages as pagesData } from '../helpers/pagesData';
import { mockData } from '@/store/mockData';
import leftPad from 'left-pad';

Vue.use(Vuex);

export const registerPageView = (step, room) => {
  window.dataLayer = window.dataLayer || [];
  const data = {
    event: 'VirtualPageview',
    ...(pagesData[step] ? pagesData[step] : {}),
  };

  window.dataLayer.push({
    ...data,
    virtualPageURL:
      room === undefined
        ? data.virtualPageURL
        : `${data.virtualPageURL}.room${room}`,
  });
};

export default new Vuex.Store({
  state: {
    offline: !window.isRunning,
    mock: false,
    step: null,
    massifError: null,
    finished: false,
    hasWon: false,
    showForm: false,
    fail: false,
    checkMail: false,
    roomData: null,
    stepData: null,
    codeAttempt: {},
    codeErrors: {},
    scrollToActive: false,
    jouwData: {
      senderFirstname: null,
      senderLastname: null,
      senderEmail: null,
      senderOptin: false,
      bevestigEmail: null,
      schiftingsVraag: null,
    },
    errors: null,
    loading: true,
  },
  mutations: {
    setCodeAttempt(state, { index, value }) {
      state.codeAttempt = {
        ...state.codeAttempt,
        [index]: value,
      };
    },
    setErrors(state, { errors }) {
      state.errors = errors;
    },
    loadInitialState: async state => {
      state.loading = true;
      let roomData;

      try {
        roomData = state.mock ? mockData : await getData();
      } catch (e) {
        // eslint-disable-next-line
        console.error(e);
      }

      // preloading images:
      const images = roomData.map(room => room.img);

      if (images.length) {
        await loadImages(images);
      }

      registerPageView(0);
      state.roomData = roomData;

      state.loading = false;
    },
    setNavigateFlag(state) {
      state.scrollToActive = true;
    },
    resetNavigateFlag(state) {
      state.scrollToActive = false;
    },
    setStep(state, { step }) {
      let askedStep = step;

      if (askedStep === null) {
        askedStep = state.roomData.findIndex(
          room => room.isActive && !room.isFinished,
        );
      }
      if (state.roomData[askedStep].isActive) {
        state.step = askedStep;
        state.stepData = state.roomData[askedStep];
      }

      registerPageView(1, askedStep);
    },
    checkCode(state) {
      const num = leftPad(
        (atob(state.stepData.code) / 3).toString(),
        state.stepData.digits,
        '0',
      );
      let codeErrors = num
        .toString()
        .split('')
        .reduce((acc, curr, index) => {
          if (state.codeAttempt[index] !== curr) {
            return {
              ...acc,
              [index]: 'wrong',
            };
          }
          return acc;
        }, {});
      if (Object.keys(codeErrors).length) {
        state.codeErrors = codeErrors;
      } else {
        state.codeErrors = {};
        registerPageView(2, state.stepData.id);
        state.hasWon = true;
      }
    },
    proceedToForm(state) {
      registerPageView(3, state.stepData.id);
      state.showForm = true;
    },
    sendData: async state => {
      if (!state.loading) {
        state.loading = true;
        try {
          await sendForm({
            formData: state.jouwData,
            roomData: state.stepData,
            code: state.codeAttempt,
          });
          registerPageView(5, state.stepData.id);
          state.checkMail = true;
          state.loading = false;
          state.codeAttempt = {};
        } catch (e) {
          state.errors = {
            connection: e,
          };
          state.loading = false;
        }
      }
    },
    sayFail(state) {
      registerPageView(4, state.stepData.id);
      state.fail = true;
    },
    resetStep(state) {
      state.step = null;
      state.stepData = null;
      state.hasWon = false;
      state.showForm = false;
      state.fail = false;
      state.checkMail = false;
      state.codeAttempt = {};
      state.codeErrors = {};
      registerPageView(0);
    },
    setJouwData(state, { name, value }) {
      const trimmed = value.trim ? value.trim() : value;
      Vue.set(state.jouwData, name, trimmed);
    },
  },
});
